import { request } from '@ithinkdt/common'
export const $FETCH = Symbol()
export let $fetch = request
export function initHttp(init) {
    $fetch = request.extend(init)
    return {
        install(app) {
            app.provide($FETCH, $fetch)
        },
    }
}
